module.exports = __webpack_public_path__ + "img/jadwellha.64859a8a.svg";